import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";
 
export const GetVaccineDoseList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/VaccineDose/GetList?` + params, null);

export const CreateVaccineDose = (data: any) =>
  POST_ENC(`${BASE_URL}/api/VaccineDose/Create`, data);